export default "__VITE_ASSET__SzHsxhCq__"